import useTranslation from 'next-translate/useTranslation';

import { Button, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useModalStockAlert } from '@core/hook';
import { EColor, EIcon, ETypographyVariant } from '@core/type';
import { ProductEntity } from '@core/type/api';
import { ModalAddStockAlert, ModalUpdateStockAlert } from '@core/widget';

export const ProductOutOfStockBlock = ({ product }: { product: ProductEntity }) => {
  const { addingProps, updatingProps, isUpdatingModal, onAlertButton } =
    useModalStockAlert(product);
  const { t: tProductShow } = useTranslation(Translate.page.PRODUCT_SHOW);
  const { t: tProduct } = useTranslation(Translate.common.PRODUCT);

  return (
    <>
      <Typography variant={ETypographyVariant.H5} color={EColor.SECONDARY} marginBottom="30px">
        {tProduct('statuses.outOfStock')}
      </Typography>
      <Button startIcon={EIcon.ALERT} onClick={onAlertButton}>
        {tProductShow('buttons.alertWhenInStock')}
      </Button>
      {isUpdatingModal ? (
        <ModalUpdateStockAlert {...updatingProps} />
      ) : (
        <ModalAddStockAlert {...addingProps} />
      )}
    </>
  );
};
